"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m3 5.5h-2.5V21h-1v-2.5H15v-1h2.5V15h1v2.5H21zM7 5h13v2H7z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "3.5",
  cy: "18",
  r: "1.5"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M18 11H7v2h6.11c1.26-1.24 2.99-2 4.89-2M7 17v2h4.08c-.05-.33-.08-.66-.08-1s.03-.67.08-1z"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "3.5",
  cy: "6",
  r: "1.5"
}, "3"), /*#__PURE__*/_jsx("circle", {
  cx: "3.5",
  cy: "12",
  r: "1.5"
}, "4")], 'FormatListBulletedAdd');